import { DEFAULT_LANGUAGE } from "./constants"

export function getLocale() {
  // return localStorage.getItem("i18nextLng") || navigator.language || DEFAULT_LANGUAGE
  return localStorage.getItem("i18nextLng") || DEFAULT_LANGUAGE
}
